import { environmentService, userService, getRequestHandler } from "@/utils/services";
import { compress, decompress } from 'lz-string';

let apiUrl = environmentService.apiUrlHotel;
let apiUrlBooking = environmentService.apiUrlBooking;
let headers = {headers:userService.authHeader()};

export const locationService = {
  getCountries,
  getCities,
};


async function getCountries () {
  let client = '1'; //userService.getActiveUser().clients[0]
  let countries = null;
  if (localStorage.getItem(`countries`)) {
    countries = JSON.parse(decompress(localStorage.getItem(`countries`)));
  }
  if (countries && countries.length > 0) {
    return await countries;
  } else {
    return await getRequestHandler(`${apiUrlBooking}/countries`, headers);
  }
}

async function getCities () {
  let client = '1'; //userService.getActiveUser().clients[0]
  let cities = null;
  if (localStorage.getItem(`cities`)) {
    cities = JSON.parse(decompress(localStorage.getItem(`cities`)));
  }
  if (cities && cities.length > 0) {
    return await cities;
  } else {
    return await getRequestHandler(`${apiUrl}/towns`, headers);
  }
}



// WEBPACK FOOTER //
// ./src/utils/services/locations/location.service.js